// extracted by extract-css-chunks-webpack-plugin
module.exports = {"day":"day_K70AH","title":"title_Jp-ae","content":"content_baBG5","mask":"mask_EzIE-","mask_active":"mask_active_7X8Ef"};